var exports = {
  "q": "UserVerifiedBadge.module__badge___YTVfQn",
};

module.exports = exports;
